import React from "react";


/**
 * Creates an array of columns for user management page (according to material-table component's format)
 * Includes personal information columns and event columns for each event (excluding lessons)
 */
const headerStyle = {textAlign: 'center', margin: 0, padding: 10, fontWeight: 'bold'};
const headerStyleEn = {textAlign: 'left', margin: 0, padding: 10, fontWeight: 'bold'};
const cellStyle = {textAlign: 'center', margin: 0, padding: 10 };
const cellStyleEn = {textAlign: 'left', margin: 0, padding: 10 };
export function getColumns() {
    return [
        { title: 'Time', field: 'time', removable: false, headerStyle: headerStyleEn, cellStyle: cellStyleEn },
        { title: 'Chair', field: 'chair_name_eng', removable: false, headerStyle: headerStyleEn, cellStyle: cellStyleEn },
        { title: 'Partner', field: 'partner_name_eng', removable: false, headerStyle: headerStyleEn, cellStyle: cellStyleEn },
        { title: 'Info Slide', field: 'info_slide', removable: false, width: "30%", headerStyle: headerStyle, cellStyle: cellStyle },
        { title: 'Motion', field: 'motion', removable: false, width: "30%", headerStyle: headerStyle, cellStyle: cellStyle },
        { title: 'Position', field: 'position', removable: false, headerStyle: headerStyleEn, cellStyle: cellStyleEn },
        { title: 'Rank', field: 'rank', removable: false, headerStyle: headerStyleEn, cellStyle: cellStyleEn },
        { title: 'Speaks', field: 'speaker_points', removable: false, headerStyle: headerStyleEn, cellStyle: cellStyleEn },
    ]
}
